import React, { PropTypes } from 'react';
import SharedTools from '../../lib/SharedTools';
import DataService from '../../lib/DataService';
import { hashHistory } from 'react-router';
import { Select } from 'antd';

const Option = Select.Option;

export default class EvaluateIndexPage extends React.Component {
  static propTypes = {
    // name: PropTypes.string.isRequired
  };

  constructor(props) {
    super(props);
    // set state
    let currentSemester = SharedTools.getCurrentSemester()
    let semesters = SharedTools.getAllSemesters(currentSemester, 20201);
    this.state = {
      semester: props.location.query.semester ? props.location.query.semester : currentSemester,
      classId: props.params.classId ? props.params.classId : 0,
      students: [],
      semesters
    };
    // bind this
  }

  componentDidMount() {
    let data = {
      class_id: this.state.classId,
      semester: this.state.semester,
      info: 'evaluation'
    }
    DataService.getStudentsList(data).then((res) => {
      this.setState({
        students: res
      })
    }).catch((error) => {
      console.log(error);
    });
  }

  goStudentObservationsListPage(student) {
    hashHistory.push(`development/evaluation-record/classes/${this.state.classId}/students/${student.id}?semester=${this.state.semester}`)
  }

  selectSemester(value) {
    if (value != this.state.semester) {
      this.setState({
        semester: value,
      }, () => {
        this.componentDidMount()
      })
    }
  }

  _selectSemesterBox() {
    return (
      <div className="select-semester-box">
        <Select value={String(this.state.semester)} style={{ width: 145 }} onChange={this.selectSemester.bind(this)}>
          {this.state.semesters.map((semester, index) => <Option value={String(semester.semester)} key={index}>{semester.semesterToString}</Option>)}
        </Select>
      </div>
    )
  }

  render() {
    return (
      <div className="evaluate-index-page archive-content-setting-class-page">
        {this._selectSemesterBox()}
        <div className="evaluate-container">
          {this.state.students.map(student => <div className="student-list" key={student.id} onClick={() => this.goStudentObservationsListPage(student)}>
            <div className="student-name">
              {student.unevaluated_count > 0 ? <span className="point"></span> : ''}
              {student.full_name}
            </div>
            <div className="evaluate-label">共{student.observation_count}条记录</div>
          </div>)}
        </div>
        
      </div>
    )
  }
} 


// WEBPACK FOOTER //
// ./app/javascript/bundles/WebPcApp/components/development/EvaluateIndexPage.jsx